import { WS_COMMANDS as WSC } from "./websocketCommands";
import { selectTreatment, setIsParticipentDrawing, setDrawingValue, setUserStatuses, setIsParticipantUpdating } from "../store/treatmentServerDataSlice";
import { setTeacherWSConnected, selectLastSeenDate } from "../store/websocketSlice";
import { selectMessageList, selectNumUnreadMessages, sendChatMessage, setMessageList, setNumUnreadMessages, setInitialMessageList, selectChatWidgetStatus, notifyOpenChatWidget } from "../store/chatSlice";
import { setIsVideoPaused, setIsVideoMuted,
  setIsExitVideo, setIsKickedFromVideo, selectIsOpentokEnabled, setOpentokReconnect,
  selectIsVideoMuted, selectIsVideoPaused, userStartVideo, userDeclineVideo,
  askToJoinVideo, setOpentokErrorMessage,
} from "../store/videoSlice";
import {
  setArticulationResult,
  setArticulationWord,
  setBoardMode,
  setDrawingPresent,
  setCurrentSpeechRecognition,
  setH5PGame,
  setIsRecording,
  setStudioActivity,
  setWordUUID,
  selectH5PGamePostMessageHandler,
  clearStudent,
  setIsLocked,
  setIsTeacherPresenting,
  setPreviewMode,
  setPreviewStudioActivity,
  setPreviewH5PGame,
  selectPreviewH5PGamePostMessageHandler,
  sendRecordingsCount,
  setIsInterruptFromTherapist,
  setIsEnabledRecording,
  setSpeechUUID,
  setIsPreviewH5PGameDone,
  setIsH5PGameDone,
  setSessionStatus,
  GAME_TIMER_SW_STATUS,
  setGameSWStatus,
  setGameTimerStatus,
  setTherapistTime,
  setIsKickedFromTreatment,
} from "../store/studentSlice";
import { H5PWebsocketUpdate, H5PPreviewWebsocketUpdate, H5PReassignGame, selectIsMultiStudentGame, setIsMultiStudentGame } from "../store/h5pGamesSlice";
import { setVideoId, setIsPlaying, setSkippedTime, setIsEnded, setIsError } from "../store/youtubeSlice";
import { sendReadingToWS, requestClearState, READING_REDUCERS, updateStudentReadingStatus } from "@app/routes/activities/reading/store/readingSlice";
import { sendSpellingToWS, getSpellingReducerByType, updateStudentSpellingStatus, updatePreviewSpellingStatus } from "@app/routes/activities/spelling/store/spellingSlice";
import { CHAT_SENDER_POSITION, CHAT_RECEIVER_POSITION, CHAT_WIDGET_STATUS as CWS } from "@app/routes/treatmentV3/components/chat/ChatUtils";
import { selectTechStatus, selectErrorList, setIsAudioPermissionGranted, setIsTabVisible, setIsVideoPermissionGranted, setIsWindowFocused } from "@app/routes/treatmentV3/store/techStatusSlice";
import { RECORDING_STATUS } from "../constants";
import { VIDEO_SESSION_PAGES } from "@app/common/data/ActivitiessEnums";
import { currentUser } from "@amplio-common/selectors/auth";

const relevantMessages = {
  [WSC.LIVE_CHECK_REQ]: (websocket) => websocket.send(JSON.stringify({ command: WSC.LIVE_CHECK_RESPONSE })),
  [WSC.HI]: (websocket, content) => {
    const state = websocket.reduxStore.getState();
    const treatment = selectTreatment(state) || {};
    const techStatus = selectTechStatus(state) || {};
    const errorList = selectErrorList(state) || {};
    if (treatment?.therapist === content?.user_id) {
      websocket.reduxStore.dispatch(setTeacherWSConnected(true));
      websocket.reduxStore.dispatch(clearStudent());
      websocket.sendJson({ command: WSC.REQUEST_CURRENT_CONTENT });
      websocket?.sendJson({ command: WSC.TECH_INIT_STATUS, initStatus: techStatus }); //notify therapist about current problems
      websocket?.sendJson({ command: WSC.TECH_INIT_ERRORS, errorList });
    }
  },
  [WSC.BYE]: (websocket, content) => {
    const state = websocket.reduxStore.getState();
    const treatment = selectTreatment(state) || {};
    if (treatment?.therapist === content?.user_id) {
      websocket.reduxStore.dispatch(setGameSWStatus(GAME_TIMER_SW_STATUS.STOPPED));
      websocket.reduxStore.dispatch(setGameTimerStatus(GAME_TIMER_SW_STATUS.STOPPED));
      websocket.reduxStore.dispatch(setBoardMode(VIDEO_SESSION_PAGES.SESSION_START));
      websocket.reduxStore.dispatch(setH5PGame({}));
      websocket.reduxStore.dispatch(setTeacherWSConnected(false));
    }
  },
  [WSC.IS_TEACHER_CONNECTED]: (websocket, content) => {
    content?.isConnected && websocket.reduxStore.dispatch(setTeacherWSConnected(true));
  },
  [WSC.WELCOME_STUDENT_VIDEO_STATS]: (websocket) => {
    const state = websocket.reduxStore.getState();
    const isVideoMuted = selectIsVideoMuted(state);
    const isVideoPaused = selectIsVideoPaused(state);
    const isOpentokEnabled = selectIsOpentokEnabled(state);
    const errorList = selectErrorList(state);
    !isOpentokEnabled && websocket.reduxStore.dispatch(setOpentokReconnect(true)); //if student disconnected from opentok - try to reconnect
    websocket.sendJson({ command: WSC.STUDENT_CURRENT_STATUS, isVideoMuted, isVideoPaused });
    websocket?.sendJson({ command: WSC.TECH_INIT_ERRORS, errorList });
  },
  [WSC.UPDATE_USERS]: (websocket, payload) => {
    websocket.reduxStore.dispatch(setUserStatuses(payload.content));
  },
  [WSC.KICK_FROM_SESSION]: (websocket) => websocket.reduxStore.dispatch(setIsKickedFromTreatment(true)),
  [WSC.SET_STUDENT_ACTIVITY]: (websocket, content) => content?.selectedActivity && websocket.reduxStore.dispatch(setStudioActivity(content.selectedActivity)),
  [WSC.SET_STUDENT_BOARD]: (websocket, content) => content?.newMode && websocket.reduxStore.dispatch(setBoardMode(content?.newMode)),
  [WSC.PRESENT_DRAWING_TO_STUDENT]: (websocket, content) => websocket.reduxStore.dispatch(setDrawingPresent(content.content)),
  [WSC.CLOSE_DRAWING_TO_STUDENT]: (websocket) => websocket.reduxStore.dispatch(setDrawingPresent(false)),
  
  [WSC.SET_GAME_TIMER_START]: (websocket) => {
    websocket.reduxStore.dispatch(setGameSWStatus(""));
    websocket.reduxStore.dispatch(setGameTimerStatus(GAME_TIMER_SW_STATUS.RUNNING));
  },
  [WSC.SET_GAME_TIMER_STOP]: (websocket) => {
    websocket.reduxStore.dispatch(setGameSWStatus(""));
    websocket.reduxStore.dispatch(setGameTimerStatus(GAME_TIMER_SW_STATUS.STOPPED));
  },
  [WSC.SET_GAME_SW_START]: (websocket) => {
    websocket.reduxStore.dispatch(setGameTimerStatus(""));
    websocket.reduxStore.dispatch(setGameSWStatus(GAME_TIMER_SW_STATUS.RUNNING));
  },
  [WSC.SET_GAME_SW_PAUSE]: (websocket) => {
    websocket.reduxStore.dispatch(setGameTimerStatus(""));
    websocket.reduxStore.dispatch(setGameSWStatus(GAME_TIMER_SW_STATUS.PAUSED));
  },
  [WSC.SET_GAME_SW_STOP]: (websocket) => {
    websocket.reduxStore.dispatch(setGameTimerStatus(""));
    websocket.reduxStore.dispatch(setGameSWStatus(GAME_TIMER_SW_STATUS.STOPPED));
  },
  [WSC.SET_GAME_TIME_SYNC]: (websocket, context) => websocket.reduxStore.dispatch(setTherapistTime(context.time)),

  [WSC.SESSION_COMPLETED]: (websocket, content) => content?.sessionStatus && websocket.reduxStore.dispatch(setSessionStatus(content?.sessionStatus)),
  // [WSC.TOGGLE_LOCK_TO_STUDENT]: (websocket, content) => content?.isLocked != null && websocket.reduxStore.dispatch(setIsLocked(content?.isLocked)),
  [WSC.SET_H5P_GAME]: (websocket, content) => {
    websocket.reduxStore.dispatch(setH5PGame(JSON.parse(content.h5pGame)));
    websocket.reduxStore.dispatch(setIsMultiStudentGame(content.isGroupMode));
  },
  [WSC.SEND_ARTICULATION_WORD]: (websocket, content) => websocket.reduxStore.dispatch(setArticulationWord(content.articulationWord)),
  // set word UUID BEFORE you set the articulation in order to allow recording to start with the current uuid
  [WSC.SET_WORD_UUID]: (websocket, content) => {
    content?.authData?.uuid && websocket.reduxStore.dispatch(setWordUUID(content.authData.uuid));
    websocket.reduxStore.dispatch(setArticulationWord(content.articulationWord));
  },
  [WSC.SEND_ARTICULATION_RESULT]: (websocket, content) => {
    content?.articulationResult != null && websocket.reduxStore.dispatch(setArticulationResult(!!content.articulationResult));
  },

  [WSC.H5P_GAME_UPDATE]: (websocket, content) => {
    const state = websocket.reduxStore.getState();
    selectH5PGamePostMessageHandler(state)(content.data);
  },

  [WSC.H5P_GAME_PREVIEW_UPDATE]: (websocket, content) => {
    const state = websocket.reduxStore.getState();
    selectPreviewH5PGamePostMessageHandler(state)(content.data);
  },
  [WSC.VIDEO_KICK_STUDENT]: (websocket) => {
    websocket.reduxStore.dispatch(setIsKickedFromVideo(true));
  },
  [WSC.VIDEO_RESET_STUDENT]: (websocket, content) => {
    websocket.reduxStore.dispatch(setIsExitVideo(content?.isExitVideo));
  },
  [WSC.VIDEO_START_OK]: (websocket) => {
    websocket.reduxStore.dispatch(userStartVideo());
  },
  [WSC.PUSH_STUDNET]: (websocket, content) => {
    if (content?.pushStudent) {
      window.location.href = `/treatment/v3/${content?.pushStudent}`; // should use react-router-dom. but it's causing issues since new CRA version
    }
  },
  [WSC.SET_IS_LOCKED]: (websocket, content) => {
    websocket.reduxStore.dispatch(setIsLocked(content.isLocked));
  },
  [WSC.SET_TEACHER_PRESENTING]: (websocket, content) => {
    websocket.reduxStore.dispatch(setIsTeacherPresenting(content.isTeacherPresenting));
  },
  [WSC.SET_PREVIEW_MODE]: (websocket, content) => {
    websocket.reduxStore.dispatch(setPreviewMode(content.mode));
  },
  [WSC.SET_PREVIEW_STUDIO_ACTVITY]: (websocket, content) => {
    websocket.reduxStore.dispatch(setPreviewStudioActivity(content.previewActivity));
  },
  [WSC.SET_PREVIEW_H5P_GAME]: (websocket, content) => {
    websocket.reduxStore.dispatch(setPreviewH5PGame({})); // quick-and-dirty - refresh the game to sync with therapist
    websocket.reduxStore.dispatch(setPreviewH5PGame(JSON.parse(content.h5pGame)));
  },
  [WSC.SET_IS_PREVIEW_H5P_GAME_DONE]: (websocket, content) => {
    const { isH5PGameDone } = content;
    websocket.reduxStore.dispatch(setIsPreviewH5PGameDone(isH5PGameDone));
  },
  [WSC.SET_IS_H5P_GAME_DONE]: (websocket, content) => {
    const { isH5PGameDone } = content;
    websocket.reduxStore.dispatch(setIsH5PGameDone(isH5PGameDone));
  },
  [WSC.SET_YOUTUBE_VIDEO_ID]: (websocket, content) => {
    websocket.reduxStore.dispatch(setVideoId(content.videoId));
  },
  [WSC.YOUTUBE_SKIPPED_TIME]: (websocket, content) => {
    websocket.reduxStore.dispatch(setSkippedTime({ skippedTime: content.skippedTime, src: "ws" }));
  },
  [WSC.IS_YOUTUBE_PLAYING]: (websocket, content) => {
    websocket.reduxStore.dispatch(setIsPlaying({ isPlaying: content.isPlaying, src: "ws" }));
  },
  // Reading
  [WSC.READING_GENERIC_SEND]: (websocket, content) => {
    const data = content?.data;
    const reducer = READING_REDUCERS[data?.reducerType];
    reducer && websocket.reduxStore.dispatch(reducer(data));
    data?.value === RECORDING_STATUS.FINISHED && websocket.reduxStore.dispatch(setIsRecording(false));
  },
  [WSC.READING_SEND_STATUS]: (websocket, content) => {
    const { status, target_user } = content;
    status && target_user && websocket.reduxStore.dispatch(updateStudentReadingStatus({ id: target_user, changes: status }));
  },
  // Spelling
  [WSC.SPELLING_GENERIC_SEND]: (websocket, content) => {
    const data = content?.data;
    const reducer = getSpellingReducerByType(data?.reducerType);
    reducer && websocket.reduxStore.dispatch(reducer(data));
  },
  [WSC.SPELLING_SEND_STATUS]: (websocket, content) => {
    const { status, target_user } = content;
    status && target_user && websocket.reduxStore.dispatch(updateStudentSpellingStatus({ id: target_user, changes: status }));
  },
  [WSC.SPELLING_SEND_PREVIEW_STATUS]: (websocket, content) => {
    const { status, target_user } = content;
    status && target_user && websocket.reduxStore.dispatch(updatePreviewSpellingStatus(status));
  },
  //speech
  [WSC.SPEECH_CLEAR_STATE]: (websocket) => {
    websocket.reduxStore.dispatch(setIsInterruptFromTherapist(true));
  },
  [WSC.SPEECH_TOGGLE_ENABLE_RECORDING]: (websocket, content) => {
    const { changes } = content;
    changes?.isEnabledRecording != null && websocket.reduxStore.dispatch(setIsEnabledRecording(changes.isEnabledRecording));
  },
  //CHAT
  [WSC.CHAT_NEW_MESSAGE]: (websocket, payload) => {
    const { newMessage } = payload || {};
    const s = websocket.reduxStore.getState();
 
    const prevMessageList = selectMessageList(s);
    const prevChatWidgetStatus = selectChatWidgetStatus(s);
    const prevNumUnreadMessages = selectNumUnreadMessages(s);
    const newNumUnreadMessages = prevChatWidgetStatus === CWS.OPEN ? prevNumUnreadMessages : prevNumUnreadMessages + 1;
    const newMessageList = [...prevMessageList, { ...newMessage, position: CHAT_RECEIVER_POSITION }];
    websocket.reduxStore.dispatch(setMessageList(newMessageList));
    websocket.reduxStore.dispatch(setNumUnreadMessages(newNumUnreadMessages));
  },
  [WSC.CHAT_GET_MESSAGE_LIST]: (websocket, payload) => {
    const { messageList, numUnreadMessage } = payload || {};
    messageList?.length > 0 && websocket.reduxStore.dispatch(setInitialMessageList(messageList));
    messageList?.length > 0 && websocket.reduxStore.dispatch(setNumUnreadMessages(numUnreadMessage));
  },
  //studio
  [WSC.STUDENT_STUDIO_ACTIVITY_UPDATE]: (websocket, content) => {
    content?.type === "stopRecord" && websocket.reduxStore.dispatch(setIsRecording(false));
    content?.type === "startRecord" && websocket.reduxStore.dispatch(setIsRecording(true));
  },
  [WSC.WHITEBOARD_UPDATE]: (websocket, content) => {
    websocket.reduxStore.dispatch(setDrawingValue(content.data));
    if (typeof content.data.updating !== "undefined") websocket.reduxStore.dispatch(setIsParticipantUpdating(content.data.updating));
    if (typeof content.isControlled !== "undefined") websocket.reduxStore.dispatch(setIsParticipentDrawing(content.isControlled));
  },
};

const websocketSimpleSend = (cmd, fieldName) => (state, action, websocket) => websocket.sendJson({ command: cmd, [fieldName]: action.payload });

const relevantActions = {
  [H5PWebsocketUpdate]: (state, action, websocket) => {
    const { data } = action.payload;
    const isGroupMode = selectIsMultiStudentGame(state);
    if (isGroupMode && data.cmd !== "initialSyncActions" && data.cmd !== "initialSyncReq") {
      const currUser = currentUser(state);
      data.playerName = currUser.name;
      websocket.sendJson({ command: WSC.H5P_GAME_UPDATE, data, group_mode: isGroupMode });
    }
    websocket.sendJson({ command: WSC.H5P_GAME_UPDATE, data, group_mode: false });
  },
  [H5PPreviewWebsocketUpdate]: (state, action, websocket) => {
    const { data } = action.payload;
    websocket.sendJson({ command: WSC.H5P_GAME_PREVIEW_UPDATE, data });
  },
  [H5PReassignGame]: websocketSimpleSend(WSC.H5P_RE_ASSIGN_CURRENT_GAME, "gameReassign"),

  [setCurrentSpeechRecognition]: websocketSimpleSend(WSC.SEND_S2T_RESULT, "s2tResult"),
  [setIsRecording]: websocketSimpleSend(WSC.SEND_IS_RECORDING, "isStudentRecording"),

  //youtube
  [setIsPlaying]: (state, action, websocket) => {
    const { src, isPlaying } = action.payload;

    src !== "ws" && websocket.sendJson({ command: WSC.IS_YOUTUBE_PLAYING, isPlaying });
  },
  [setSkippedTime]: (state, action, websocket) => {
    const { src, skippedTime } = action.payload;
    src !== "ws" && websocket.sendJson({ command: WSC.YOUTUBE_SKIPPED_TIME, skippedTime });
  },
  [setIsEnded]: websocketSimpleSend(WSC.IS_ENDED_YOUTUBE_VIDEO, "isEnded"),
  [setIsError]: websocketSimpleSend(WSC.IS_ERROR_YOUTUBE_VIDEO, "isError"),
  
  //video
  // [userStartVideo.fulfilled]: websocketSimpleSend(WSC.VIDEO_START_OK, "isVideoOn"),
  [setIsVideoPaused]: websocketSimpleSend(WSC.TOGGLE_STUDENT_PAUSE_BY_STUDENT, "isVideoPaused"),
  [setIsVideoMuted]: websocketSimpleSend(WSC.TOGGLE_STUDENT_MUTE_BY_STUDENT, "isVideoMuted"),
  [userDeclineVideo]: websocketSimpleSend(WSC.STUDENT_DISAPPROVED_VIDEO, "isVideoDisapproved"),
  [sendRecordingsCount]: websocketSimpleSend(WSC.SEND_RECORDINGS_COUNT, "recordingsCount"),
  [askToJoinVideo]: websocketSimpleSend(WSC.ASK_TO_JOIN_VIDEO, "joinVideo"),

  // Reading
  [sendReadingToWS]: (state, action, websocket) => {
    const { boardId } = action.payload;
    websocket?.sendJson({ command: WSC.READING_GENERIC_SEND, data: action.payload, target_user: boardId });
  },
  [requestClearState]: (state, action, websocket) => {
    const { boardId } = action.payload;
    websocket?.sendJson({ command: WSC.READING_CLEAR_STATE, target_user: boardId });
  },

  // Spelling
  [sendSpellingToWS]: (state, action, websocket) => {
    const { boardId } = action.payload;
    websocket?.sendJson({ command: WSC.SPELLING_GENERIC_SEND, data: action.payload, target_user: boardId });
  },

  // Speech
  [setSpeechUUID]: (state, action, websocket) => {
    websocket?.sendJson({ command: WSC.SPEECH_SEND_UUID, uuid: action.payload });
  },

  //chat
  [sendChatMessage]: (state, action, websocket) => {
    const { newMessage } = action?.payload || {};
    if (action.payload) {
      const prevMessageList = selectMessageList(state);
      const newMessageList = [...prevMessageList, { ...newMessage, position: CHAT_SENDER_POSITION }];
      websocket.reduxStore.dispatch(setMessageList(newMessageList));
      websocket?.sendJson({ command: WSC.CHAT_NEW_MESSAGE, newMessage });
    }
  },

  //tech stats
  // [setInitialTechStatus]: (state, action, websocket) => {
  //   websocket?.sendJson({ command: WSC.TECH_INIT_STATUS, initStatus: action?.payload });
  // },
  [setIsWindowFocused]: (state, action, websocket) => {
    websocket?.sendJson({ command: WSC.TECH_WINDOW_FOCUS_STATUS, isWindowFocused: action?.payload });
  },
  [setIsTabVisible]: (state, action, websocket) => {
    websocket?.sendJson({ command: WSC.TECH_WINDOW_VISIBILITY_STATUS, isTabVisible: action?.payload });
  },
  [setIsAudioPermissionGranted]: (state, action, websocket) => {
    websocket?.sendJson({ command: WSC.TECH_AUDIO_PERMISSIONS, isAudioPermissionGranted: action?.payload });
  },
  [setIsVideoPermissionGranted]: (state, action, websocket) => {
    websocket?.sendJson({ command: WSC.TECH_VIDEO_PERMISSIONS, isVideoPermissionGranted: action?.payload });
  },
  [setOpentokErrorMessage]: (state, action, websocket) => {
    websocket?.sendJson({ command: WSC.TECH_OPENTOK_ERROR, studentOpentokError: action?.payload });
  },
  [notifyOpenChatWidget]: (state, action, websocket) => {
    websocket?.sendJson({ command: WSC.CHAT_WIDGET_OPENED });
  },
  [setBoardMode]: (state, action, websocket) => {
    websocket?.sendJson({ command: WSC.TECH_RECEIVE_ACTIVITY, boardMode: action.payload });
  },
};

export const handleCheckTeacherConnectedStatus = websocket => {
  const byPassUntilFixed = true;
  if (byPassUntilFixed) { return; }
  const reduxState = websocket.reduxStore.getState();
  const lastSeenDate = selectLastSeenDate(reduxState);

  if (!lastSeenDate) {
    websocket.sendJson({ command: WSC.LIVE_CHECK_REQ });
  }
};

export const handleStudentWSMessage = (websocket, payload) => {
  const command = payload?.content?.command || payload?.command || undefined;
  relevantMessages[command]?.(websocket, payload.content);
};

export const handleStudentTreatmentActions = (state, action, websocket) => {
  relevantActions[action?.type]?.(state, action, websocket);
};
